export const USD = 'USD';
